import { MonoTypeOperatorFunction, Observable, catchError, of, throwError } from 'rxjs';
import { readSubTaskCompletionRefusal, readTaskCompletionRefusal } from '@workbuddy/entities/work.task/task.completion.refusal';

/** The task editor services swallow a failed write into their error stream; the gate's refusals pass through instead, so the completion flow can turn them into their dialog. */
// The error is `any` as rxjs' catchError hands it over, so each service keeps feeding its existing error stream unchanged.
export function rethrowTaskCompletionRefusal<T>(report: (error: any) => void): MonoTypeOperatorFunction<T | null> {

  return (source: Observable<T | null>) => source
    .pipe(
      catchError(error => {
        if (readTaskCompletionRefusal(error) || readSubTaskCompletionRefusal(error)) return throwError(() => error);
        report(error);
        return of(null);
      }),
    );
}
